module.exports = __webpack_public_path__ + "static/media/pulsar-light-transparent.4a9a79c1.png";